module.exports = __webpack_public_path__ + "img/profile_dp-1.58cc530f.png";